import { render, staticRenderFns } from "./MatchHeatTable.vue?vue&type=template&id=a3d59dd8&scoped=true&"
import script from "./MatchHeatTable.vue?vue&type=script&lang=js&"
export * from "./MatchHeatTable.vue?vue&type=script&lang=js&"
import style0 from "./MatchHeatTable.vue?vue&type=style&index=0&id=a3d59dd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d59dd8",
  null
  
)

export default component.exports